import React from "react";
import { Grid, createStyles, makeStyles, TextField } from "@material-ui/core";

import { Formik } from "formik";
import * as Yup from "yup";

import { convertToHTML } from "draft-convert";
// import { GET_GROUP, POST_INSERT_AXIS } from "../../../services/options";
import { SelectApi } from "../../../Components/SelectsApi";
import { useSnackbar } from "notistack";
import api from "../../../services/Api";
import { ButtonSuccess } from "../../../Components/ButtonSuccess";
import DefaultModal, {
  DefaultModalActions,
  DefaultModalContent,
} from "../../../Components/DefaultModal";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "grid",
      [theme.breakpoints.up("xs")]: {
        width: 380,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("sm")]: {
        width: 450,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("md")]: {
        width: 500,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("lg")]: {
        width: 500,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("xl")]: {
        width: 550,
        padding: theme.spacing(0, 1, 0, 1),
      },
    },
  })
);

const initialValues = {
  name: "",
};

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Obrigatório"),
});

export default function NewTaskType({ open, setOpen, updateData }) {
  const { enqueueSnackbar } = useSnackbar();

  const submit = async (values, { setSubmitting }) => {
    console.log(values);
  };

  return (
    <DefaultModal open={open} handleClose={() => setOpen()} title="Novo Tipo de Etapa">
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={submit}>
        {(props) => <Forms {...props} />}
      </Formik>
    </DefaultModal>
  );
}

const Forms = (props) => {
  const classes = useStyles();
  const {
    values,
    touched,
    errors,
    isSubmitting,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = props;

  return (
    <form onSubmit={handleSubmit} noValidate>
      <DefaultModalContent dividers>
        <Grid container className={classes.root} spacing={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              maxRows={5}
              variant="outlined"
              size="small"
              id="name"
              label="Nome"
              name="name"
              autoFocus
              inputProps={{ autoComplete: "off" }}
              onChange={handleChange}
              value={values.name}
              error={touched.name && Boolean(errors.name)}
              helperText={touched.name && errors.name}
            />
          </Grid>
        </Grid>
      </DefaultModalContent>
      <DefaultModalActions style={{ marginRight: "0.5rem" }}>
        <ButtonSuccess
          style={{ width: 120 }}
          variant="contained"
          color="primary"
          type="submit"
          success={false}
          loading={isSubmitting}
        >
          Criar
        </ButtonSuccess>
      </DefaultModalActions>
    </form>
  );
};

